// Class for a native <select>, matching the shadcn Input look. Use cn(selectClass, extra) for extras.
export const selectClass = 'h-9 rounded-md border border-input bg-transparent px-2 text-sm shadow-xs outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 dark:bg-input/30';
